import {api} from './../api'

export const docs = {
  namespaced: true,
  state: {
    docs: [],
    currentPageDocs: [],
    selectedDoc: {},
    pagination: {
      currentPage: 1,
      lastPage: 1000
    },
    query: '',
    error: null
  },
  mutations: {
    setDocs(state, payload=[]) {
      state.docs = payload
    },
    setCurrentPageDocs(state, payload=[]) {
      state.currentPageDocs = payload
    },
    pushToDocs(state, payload=[]) {
      state.docs = [...state.docs, ...payload]
    },
    editDoc(state, {editedID, newValue}) {
      const withoutEdited = state.docs.filter(({id}) => id === editedID)
      state.docs = [...withoutEdited, newValue]
    },
    initPagination(state, { currentPage=1, lastPage=1000 } = {}) {
      state.pagination = {
        currentPage,
        lastPage
      }
    },
    setPage(state, payload) {
      state.pagination.currentPage = payload
    },
    setLastPage(state, payload) {
      state.pagination.lastPage = payload
    },
    setSelectedDoc(state, payload) {
      state.selectedDoc = payload
    },
    setQuery(state, newQuery) {
      state.query = newQuery
    },
    setError(state, error) {
      state.error = error
    }
  },
  actions: {
    async getDocs({commit, state}, {filters, page, init}) {
      try {
        if(init) {
          commit('setPage', 1)
          commit('setDocs', [])
        } else {
          commit('setPage', page ?? state.pagination.currentPage+1)
        }

        commit('setQuery', filters.q?.replace('-', ' '))

        if(state.pagination.currentPage >= state.pagination.lastPage && !init) return

        filters.page = state.pagination.currentPage
        filters.q = state.query

        const query = Object.keys(filters)
          .filter(key => !!filters[key])
          .reduce((acc, key) => acc += `${key}=${filters[key]}&`, '?')

        const { data } = await api.get(`/docs${query}`)

        const sortedData = data.data.sort((a, b) => new Date(b.creation_date) - new Date(a.creation_date))
        commit('pushToDocs', sortedData)
        commit('setCurrentPageDocs', sortedData)
        commit('setLastPage', data.last_page)
      } catch(e) {
        console.error(e)
        commit('setError', e)
      }
    },
    async getDocById({commit}, id=0) {
      try {
        const response = await api.get(`/docs/${id}`)
        commit('setSelectedDoc', response.data)
      } catch(e) {
        console.error(e)
        commit('setError', e)
      }
    },
    async addDoc({ commit }, doc) {
      try {
        const {data} = await api.post('/docs', doc)
        commit('pushToDocs', [data])
        return { id: data.id }
      } catch(e) {
        return { error: e.response}
      }
    },
    async editDoc({ commit }, { id, doc }) {
      try {
        const  { data } = await api.put(`/docs/${id}`, doc)
        commit('editDoc', { editedID: id, newValue: data })
        return { id: data.id }
      } catch(e) {
        return { error: e.response }
      }
    }
  }
}
